import { computed } from '@ember/object';
import Component from '@ember/component';
import { isEmpty } from '@ember/utils';
import computedDefaultTo from 'cio/utils/computed-default-to';

// Explicitly defining all classes so that they're picked up by tailwind
const GAP_SIZE_MARGINS_ROW = {
  xxs: 'mr-0.5',
  xs: 'mr-1',
  sm: 'mr-1.5',
  md: 'mr-2',
  lg: 'mr-3',
  xl: 'mr-6',
};

const GAP_SIZE_MARGINS_COLUMN = {
  xxs: 'mb-0.5',
  xs: 'mb-1',
  sm: 'mb-1.5',
  md: 'mb-2',
  lg: 'mb-3',
  xl: 'mb-6',
};

export default class Base extends Component {
  // external API
  uuid = null;

  @computedDefaultTo('row') direction;

  @computedDefaultTo('xs') gapSize;

  @computedDefaultTo('md') size;

  variation = null;

  onApply() {}

  // internal API
  _onApply() {}

  get errors() {
    return null;
  }

  @computed('errors.[]')
  get errorMessage() {
    if (isEmpty(this.errors)) {
      return '';
    }

    return this.errors
      .map((error) => {
        // When combining multiple error messages make sure we remove full stops,
        // otherwise we may end with full stops followed by commas.
        return error.replace(/\.$/, '');
      })
      .join(', ')
      .concat('.');
  }

  @computed('direction', 'gapSize', 'variation')
  get _marginClass() {
    if (this.variation === 'compact') {
      return '';
    }

    if (this.direction === 'row') {
      return GAP_SIZE_MARGINS_ROW[this.gapSize];
    } else if (this.direction === 'column') {
      return GAP_SIZE_MARGINS_COLUMN[this.gapSize];
    }

    return '';
  }

  @computed('size', 'variation')
  get _dropdownClass() {
    let classes = ['dropdown-toggle--condition'];

    if (this.size) {
      classes.push(`dropdown-toggle--${this.size}`);
    }

    if (this.variation) {
      classes.push(`dropdown-toggle--${this.variation}`);
    }

    if (this.dropdownClass) {
      classes.push(this.dropdownClass);
    }

    return classes.join(' ');
  }
}
